<template>
  <div class="percentage-container">
  <svg :height= "radius * 2" :width= "radius * 2">
    <circle
      stroke="white"
      :stroke-dasharray="circumference + ' ' + circumference"
      :style="{ strokeDashoffset: strokeDashoffset }"
      :stroke-width="stroke"
      fill="transparent"
      :r="normalizedRadius"
      :cx="radius"
      :cy="radius"
    />
    </svg>
    <span class="percentage-text">{{progress}} %</span>
  </div>
</template>


<style lang="scss" scoped>

  .percentage-container{
    position:relative;
    margin:20px;
    text-align:center;
    circle {
      transition: stroke-dashoffset 1.5s ease-out;
      transform: rotate(-90deg);
      transform-origin: 50% 50%;
    }
    .percentage-text{
      color:white;
      position:absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-size:calc(24px + .4vw);
      margin:auto;
    }
  }

</style>


<script>
  export default {
    data() {
      const normalizedRadius = this.radius - this.stroke * 2;
      const circumference = normalizedRadius * 2 * Math.PI;    
      return {
        normalizedRadius,
        circumference
      };
    },
    computed: {
      strokeDashoffset() {
        return this.circumference - this.progress / 100 * this.circumference;
      }
    },
    method: {
      countToProgress() {
        setInterval( function() {
          alert("Hello"), 1000
        })
      }
    },
    props: {
      radius: Number,
      progress: Number,
      stroke: Number
    }
  }
</script>



 
      